import http from '../mixins/http'
import global from '../mixins/global'
import axios from 'axios'

const REQUIRED = `Este campo é obrigatório`
const MIN = (min) => {
	return `Este campo precisa ter ao menos "${min}" caracteres`
}
const MAX = (max) => {
	return `Este campo não pode ter mais que "${max}" caracteres`
}
const MIN_NUMBER = (min) => {
	return `Este campo precisa ter ao menos "${min}"`
}
const MAX_NUMBER = (max) => {
	return `Este campo não pode ter mais que "${max}"`
}
const SIZE = (size) => {
	return `Este campo precisa ter exatamente "${size}" caracteres`
}
const NO_PAST_DATE = `Precisa ser uma data futura`
const EMAIL = `Este e-mail é inválido`
const CPF = `Este cpf é inválido`
const CEP = `Este cep é inválido`
const EMAIL_RX =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const CPF_RX = /(\d{3}).(\d{3}).(\d{3})-(\d{2})/
const CEP_RX = /^[0-9]{2}.[0-9]{3}-[0-9]{3}$/

const IsValidObject = (...objects) => {
	let isValid = true
	objects.find((object) => {
		if (object === undefined || object === null) {
			isValid = false
			return true
		} else {
			Object.entries(object).find((propValue) => {
				const [key, value] = propValue
				if (value === undefined || value === null || propValue === '') {
					isValid = false
					return true
				}
			})
			if (!isValid) {
				return true
			}
		}
	})
	return isValid
}

export class Model {
  scripts = []
  validationRules = []
  atributos = {}

  constructor() {
    Object.assign(this, http.methods)
    Object.assign(this, global.methods)
  }

  Validate(validation, value) {
    if (validation.required) {
      if (!IsValidObject(value)) {
        return {
          error: true,
          errorMsg: REQUIRED,
        };
      }
      let values = Object.values(value)
      if (values.length > 0) {
        let err = false
        // console.warn("KEYS", values);
        for (let i = 0; i < values.length; i++) {
          err =
            values[i] === undefined ||
            values[i] === null ||
            values[i].length < 1
          if (err) i = values.length
        }
        if (err) {
          return {
            error: true,
            errorMsg: REQUIRED,
          };
        }
      } else {
        if (value === undefined || value === null || value.length < 1) {
          return {
            error: true,
            errorMsg: REQUIRED,
          };
        }
      }
    }
    if (validation.min) {
      if (validation.type === 'Number') {
        if (Number(value) < validation.min) {
          return {
            error: true,
            errorMsg: MIN_NUMBER(validation.min),
          };
        }
      } else {
        if (value.length < validation.min) {
          return {
            error: true,
            errorMsg: MIN(validation.min),
          };
        }
      }

    }
    if (validation.max) {
      if (validation.type === 'Number') {
        if (Number(value) > validation.max) {
          return {
            error: true,
            errorMsg: MAX_NUMBER(validation.max),
          };
        }
      } else {
        if (value.length > validation.max) {
          return {
            error: true,
            errorMsg: MAX(validation.max),
          };
        }
      }
    }
    if (validation.size) {
      if (value.length !== validation.size) {
        return {
          error: true,
          errorMsg: SIZE(validation.size),
        };
      }
    }
    if (validation.custom) {
      switch (validation.custom) {
        case "email": {
          if (!EMAIL_RX.test(String(value.trim()).toLowerCase())) {
            return {
              error: true,
              errorMsg: EMAIL,
            };
          }
          break;
        }
        case "cpf": {
          if (!CPF_RX.test(String(value.trim()))) {
            return {
              error: true,
              errorMsg: CPF,
            };
          }
          break;
        }
        case "cep": {
          if (!CEP_RX.test(value.trim())) {
            return {
              error: true,
              errorMsg: CEP,
            };
          }
          break;
        }
        case "no-past-date": {
          let date = new Date();
          if (value.year >= date.getFullYear()) {
            if (value.month >= date.getMonth()) {
              break;
            }
          }
          return {
            error: true,
            errorMsg: NO_PAST_DATE,
          };
        }
        default: {
          break;
        }
      }
    }
    return {
      error: false,
      errorMsg: undefined,
    };
  };

  skipper(rules, atributes, nameAtribute) {
    return !!rules.find((rule) => {
      //forEach para cada regra
      //regra dos atributos = verifica se a key do obj atributos é igual o ruleo da regra "payment == payment"
      const [key, valorAtributo] = Object.entries(atributes).find(
        ([nomeAtributo, value]) => nomeAtributo == rule.name
      );
      //Se o model (modelo de pagamento por ex, cred/boleto) for igual ao passado na regra
      if (rule.tipo === 'diferente') {
        if (
          valorAtributo.model !== rule.value &&
          rule.validate.find((name) => name === nameAtribute)
        ) {
          return true
        }
      } else {
        if (
          valorAtributo.model === rule.value &&
          rule.validate.find((name) => name === nameAtribute)
        ) {
          //e na regra possuirem o mesmo name pra validação
          return true;
        }
      }
    });
  }

  PostScripts(scripts, value) {
    switch (scripts) {
      case "no-white-spaces": {
        return String(value).replaceAll(" ", "")
      }
      default: {
        return value
      }
    }
  }

  isValid() {
    let errors = 0;

    Object.entries(this.atributos).forEach(([key ,items]) => {
      if (!this.skipper(this.validationRules, this.atributos, key)) {
        items.errors = this.Validate(items.validator, items.model)
        if (items.errors.error) errors++
      }
    });

    this.errors = errors

    if (this.errors > 0) {
      console.error(
        "Validation",
        this.errors,
        "Errors",
        Object.entries(this.atributos).filter(([key, item]) => item.errors.error)
      );
      return false
    }
    return true
  }

  toModel(items, scripts = undefined, validationRules = []) {
    let jsonData = {};

    Object.entries(items).forEach((item) => {
      let [key, valor] = item
      let scriptValue = undefined
      let postScripts = false

      if (scripts) {
        let found = scripts.find((script) => script.name === key)
        if (found) {
          postScripts = true
          scriptValue = found.script
        }
      }

      var value = valor.model

      if (
        validationRules.length === 0 ||
        !this.skipper(validationRules, items, key)
      ) {
        if (item.validator) {
          switch (item.validator.type) {
            case "String":
              jsonData[key] = postScripts
                ? this.PostScripts(scriptValue, value)
                : String(value);
              break;

            case "Number":
              jsonData[key] = postScripts
                ? Number(this.PostScripts(scriptValue, value))
                : String(value);
              break;

            default: {
              jsonData[key] = postScripts
                ? this.PostScripts(scriptValue, value)
                : value;
              break;
            }
          }
        } else {
          jsonData[key] = value
        }
      }
    });
    return jsonData;
  }

  limpaForm(objetos) {
    Object.keys(objetos).forEach((key) => {
      if (typeof (objetos[key].model) == Object) {
        this.limpaForm(objetos[key].model)
      } else {
        objetos[key].model = objetos[key] instanceof Atributos ? objetos[key].default : ""
				objetos[key].errors.error = false
				objetos[key].errors.errorMsg = ''
      }
    })
  }

  static _axios(url, method, options = {}) {
    const request = axios.create({
      baseURL: this.getURL_WS(),
      headers: {
        Authorization: this.getToken()
      }
    })
    request({
      method,
      url,
      ...options
    }).then((response) => {
      let retorno = response.data
      if (!(typeof retorno === 'string')) {
        retorno._request = true
      }

      if (retorno.status == 'sucesso' && !(typeof retorno === 'string')) {
        retorno._status = true
      } else {
        if (retorno.status == 'erro' && retorno.message) {
          window.bus.$emit('exibir-notificacao', { type: 'danger', text: retorno.message })
        } else {
          const responseText = retorno.responseText ? retorno.responseText : retorno
          retorno = {
            responseText: responseText,
            _status: false,
            _request: false,
            status: 500
          }
          window.bus.$emit('modal-erro-show', retorno);
        }
      }

      if (options.callback) {
        options.callback(retorno)
      }
    })
      .catch((retorno) => {
        if (options.catch) {
          options.catch(retorno)
        }
        retorno.response.responseText = retorno.response?.responseText ? retorno.response.responseText : retorno.response.data

        bus.$emit('modal-erro-show', retorno.response);
      })
      .finally((retorno) => {
        if (options.finally) {
          options.finally(retorno)
        }
      })
  }

  static getURL_WS(uri) {
    if (typeof uri === 'undefined') {
      return $config.get('WS')
    } else {
      if (uri.substring(0, 1) == '/') {
        return $config.get('WS') + uri
      } else {
        return $config.get('WS') + '/' + uri
      }
    }
  }

  static getToken() {
    return $sessao.getToken()
  }

  preencheAtributos(retorno) {
    Object.keys(retorno).forEach((campoTabela) => {
      if (campoTabela in this.atributos) {
        this.atributos[campoTabela].model = retorno[campoTabela]
      } else {
        this.atributos[campoTabela] = new Atributos(retorno[campoTabela], { required: false })
      }
    })
  }

}

export class Validator {

  required = undefined
  min = undefined
  max = undefined
  size = undefined
  custom = undefined
  type = undefined

  constructor(verify) {
    Object.assign(this, verify)
  }
}

export class Atributos {
  model = "";
	default = ""
  validator = {}
  errors = {
    error: false,
    errorMsg: "",
  }

  constructor(model, validacao = null, errorMsg = undefined) {
    this.validator = new Validator(validacao)
    this.errors.errorMsg = errorMsg
    this.model = model
		this.default = model
  }
}
